import { useLayoutEffect } from 'react'
import { isAndroid } from 'react-device-detect'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

/**
 * 구 베이직학생앱의 `/signature-workbook-lectures/:signatureType?curriculumKey=...` 브릿지 페이지 포팅.
 *
 * 신 앱은 signatureType path param을 사용하지 않고 curriculumKey query만 사용.
 * 네이티브 딥링크에는 signatureType을 그대로 전달(네이티브 컨트랙트 유지), fallback에서는 curriculumKey만 사용.
 *
 * 참고: 구 /Users/choi/dev/mathflat-student/src/page/SignatureWorkbookLecturePage/SignatureWorkbookLectureLinkPage.tsx
 */
const SignatureWorkbookLectureLinkPage = () => {
  const navigate = useNavigate()
  const { signatureType } = useParams<{ signatureType: 'basic' | 'concept' }>()
  const [searchParams] = useSearchParams()
  const curriculumKey = searchParams.get('curriculumKey')

  useLayoutEffect(() => {
    // 구 앱과 동일한 가드: signatureType은 'basic' 또는 'concept'만 허용
    if (
      !curriculumKey ||
      !signatureType ||
      (signatureType !== 'basic' && signatureType !== 'concept')
    ) {
      navigate('/', { replace: true })
      return
    }

    const encodedKey = encodeURIComponent(curriculumKey)

    // 네이티브 앱 자동 실행 시도 (네이티브는 signatureType을 소비)
    const link = document.createElement('a')
    link.href = isAndroid
      ? `intent://signature-book?curriculumKey=${encodedKey}&signatureType=${signatureType}#Intent;S.browser_fallback_url=${encodeURIComponent(
          `${window.location.origin}/student/lecture/signature-workbook/list?curriculumKey=${encodedKey}`,
        )};scheme=mathflat-student;package=iclass.mathflat.parent.student;end`
      : `mathflat-student://signature-book?curriculumKey=${encodedKey}&signatureType=${signatureType}`
    link.click()

    // 앱 미설치 환경: curriculumKey query만 사용하여 신 앱 리스트로 이동
    const redirectURI = `/student/lecture/signature-workbook/list?curriculumKey=${encodedKey}`
    navigate(redirectURI, { replace: true })
  }, [curriculumKey, signatureType])

  return <div />
}

export default SignatureWorkbookLectureLinkPage
